module.exports = __WEBPACK_EXTERNAL_MODULE_sGQ9__;